export enum CollectionVersionStatusFields {
    Id = "id",
    Label = "label",
    Enabled = "enabled",
}

export interface ICollectionVersionStatus {
    id: string;
    label: string;
    enabled: boolean;
}

export interface ICreateCollectionVersionStatus extends Omit<ICollectionVersionStatus, "id"> {}
export interface IUpdateCollectionVersionStatus extends Partial<ICollectionVersionStatus> {}

export enum CollectionVersionStatusOperationKey {
    Insert = "insert",
    Set = "set",
    Move = "move",
    Remove = "remove",
}

export type BuildPurchaseOrderDoorGroupMutateOperationParam =
    | {
          type: CollectionVersionStatusOperationKey.Insert;
          value: {
              index: number;
              value: ICreateCollectionVersionStatus;
          };
      }
    | {
          type: CollectionVersionStatusOperationKey.Set;
          value: {
              index: number;
              value: IUpdateCollectionVersionStatus;
          };
      }
    | {
          type: CollectionVersionStatusOperationKey.Remove;
          value: {
              index: number;
          };
      }
    | {
          type: CollectionVersionStatusOperationKey.Move;
          value: {
              index: number;
              destination_index: number;
          };
      };

export interface ICollectionVersionStatusOperation {
    [CollectionVersionStatusOperationKey.Insert]: {
        index: number;
        value: ICreateCollectionVersionStatus;
    };
    [CollectionVersionStatusOperationKey.Set]: {
        index: number;
        value: IUpdateCollectionVersionStatus;
    };
    [CollectionVersionStatusOperationKey.Move]: {
        index: number;
        destination_index: number;
    };
    [CollectionVersionStatusOperationKey.Remove]: {
        index: number;
    };
}

export const buildCollectionVersionStatusMutateOperation = (
    operation: CollectionVersionStatusOperationKey,
    value: ICollectionVersionStatusOperation[CollectionVersionStatusOperationKey]
): Partial<ICollectionVersionStatusOperation> | null => {
    let operationValue;
    switch (operation) {
        case CollectionVersionStatusOperationKey.Insert:
        case CollectionVersionStatusOperationKey.Set:
        case CollectionVersionStatusOperationKey.Move:
        case CollectionVersionStatusOperationKey.Remove:
            operationValue = {
                ...(value as any),
            };
            break;
        default: {
            return null;
        }
    }
    // Not intuitive way to reorder. If destination_index > index, destination_index must increment 1
    if (operation === CollectionVersionStatusOperationKey.Move) {
        if (operationValue.destination_index > operationValue.index) {
            operationValue.destination_index += 1;
        }
    }

    return {
        [operation]: operationValue,
    };
};
